import { Printing } from "../services/printing/printing.jsx";
import { Copying } from "../services/copying/copying.jsx";
import { Faxing } from "../services/faxing/faxing.jsx";
import { Scanning } from "../services/scanning/scanning.jsx";
import { MdAdfScanner } from "react-icons/md";
import { FaCopy, FaFax } from "react-icons/fa";
import { FaPrint } from "react-icons/fa6";

export const PRINTING = {
  name: "Printing",
  icon: FaPrint,
  component: Printing,
};

export const ALL_SERVICES = [
  PRINTING,
  {
    name: "Scanning",
    icon: MdAdfScanner,
    component: Scanning,
  },
  {
    name: "Copying",
    icon: FaCopy,
    component: Copying,
  },
  {
    name: "Faxing",
    icon: FaFax,
    component: Faxing,
  },
];
